
    import './styles.scoped.css';
    export default {
  "alert": "awsui_alert_mx3cw_1picj_189",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_1picj_1",
  "root": "awsui_root_mx3cw_1picj_211",
  "hidden": "awsui_hidden_mx3cw_1picj_249",
  "with-dismiss": "awsui_with-dismiss_mx3cw_1picj_299",
  "with-action": "awsui_with-action_mx3cw_1picj_299",
  "breakpoint-default": "awsui_breakpoint-default_mx3cw_1picj_305",
  "header": "awsui_header_mx3cw_1picj_312",
  "action": "awsui_action_mx3cw_1picj_316",
  "action-slot": "awsui_action-slot_mx3cw_1picj_321",
  "action-button": "awsui_action-button_mx3cw_1picj_322",
  "alert-focus-wrapper": "awsui_alert-focus-wrapper_mx3cw_1picj_326",
  "text": "awsui_text_mx3cw_1picj_355",
  "icon": "awsui_icon_mx3cw_1picj_362",
  "message": "awsui_message_mx3cw_1picj_365",
  "icon-size-medium": "awsui_icon-size-medium_mx3cw_1picj_373",
  "icon-size-big": "awsui_icon-size-big_mx3cw_1picj_376",
  "icon-size-normal": "awsui_icon-size-normal_mx3cw_1picj_379",
  "content": "awsui_content_mx3cw_1picj_383",
  "dismiss": "awsui_dismiss_mx3cw_1picj_387",
  "dismiss-button": "awsui_dismiss-button_mx3cw_1picj_392",
  "type-error": "awsui_type-error_mx3cw_1picj_396",
  "type-warning": "awsui_type-warning_mx3cw_1picj_404",
  "type-success": "awsui_type-success_mx3cw_1picj_412",
  "type-info": "awsui_type-info_mx3cw_1picj_420"
};
  